import * as React from "react";
import { DiaryCompliance } from "webportalclient";
import { groupBy, maxBy } from "lodash";
import Modal from "../../misc/components/modal";
import { DateTimeAccuracy, LocalizedDateTime } from "../../misc/components/LocalizedDateTime";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";

interface DiaryComplianceModalProps {
    records: DiaryCompliance[];
    onClose: () => void;
}

export const DiaryComplianceModal = ({ records, onClose }: DiaryComplianceModalProps) => {
    const groupedComplianceRecords = groupBy(records.map(c => ({
        ...c,
        complianceName: c.complianceName === null ? "Device Compliance" : c.complianceName
    })), r => r.complianceName);

    let latestCompliances: any[] = [];

    for (const [k, v] of Object.entries(groupedComplianceRecords)) {
        const latest = maxBy(v, c => c.occurred);
        latestCompliances.push({ name: k, latest: latest });
    }

    latestCompliances = latestCompliances.sort((a, b) => a.name - b.name);

    return (
        <Modal show={true} closeModalHandler={onClose} header="Subject Compliance">
            <div className="modal-body">
                {latestCompliances.length === 0 ? <Alert show={true} category={AlertCategoryEnum.Info}>No compliance recorded</Alert>
                    : <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Current Compliance</th>
                                <th>Last Calculated</th>
                            </tr>
                        </thead>
                        <tbody>

                            {latestCompliances.map(r => {
                                const compliancePercentage = r.latest.expected != 0
                                    ? `(${((r.latest.recorded / r.latest.expected) * 100).toFixed(0)}%)`
                                    : '';

                                return (
                                    <tr>
                                        <td>
                                            {r?.name ?? "Device Compliance"}
                                        </td>
                                        <td>
                                            {`${r.latest.recorded}/${r.latest.expected} ${compliancePercentage}`}
                                        </td>
                                        <td>
                                            {<LocalizedDateTime time={r.latest.occurred} accuracy={DateTimeAccuracy.Second} />}
                                        </td>
                                    </tr>)
                            })}
                        </tbody>
                    </table>}
            </div>
        </Modal>
    );
}
